import React, { useEffect } from 'react';

import '../App.css';
import "/node_modules/primereact/resources/themes/lara-light-cyan/theme.css";
import "/node_modules/primeflex/primeflex.css";
import '/node_modules/primeicons/primeicons.css';

import {BrowserRouter as Router, Routes, Route} from "react-router-dom";

import OrganizationAccount from "./OrganizationAccount";
import SocialRedirectLanding from "./SocialRedirectLanding";
import GoogleButton from "./GoogleButton";
import GenericObjects from "./GenericObjects";
import Brands from "./Brands";
import Reviews from "./Reviews";
import Enums from "./Enums";
import ABACPanel from "./ABACPanel";
import OgMenu from "./OgMenu";
import {useAuth} from "../useAuth";
import ErrorMessage from './ErrorMessage';

function MainApp() {

    const {ogOrgId} = useAuth();


    useEffect(() => {
        document.title = ogOrgId ? "Objects Grid" : "Objects Grid Login";
    }, [ogOrgId]);

    return (
        <Router>
            <div className="grid">
                <div className="col-1"></div>
                <div className="col-10 m-3">
                    <div className="grid">
                        {ogOrgId && (
                            <div className="col-12 lg:col-2">
                                <OgMenu />
                            </div>
                        )}
                        <div className="col-12 lg:col-10">
                            <Routes>
                                <Route path="/" element={<GoogleButton />} />
                                <Route path="/redirected" element={<SocialRedirectLanding/>} />
                                <Route path="/organisation" element={<OrganizationAccount />} />
                                <Route path="/generic-objects" element={<GenericObjects />} />
                                <Route path="/brands" element={<Brands />} />
                                <Route path="/reviews" element={<Reviews />} />
                                <Route path="/enums" element={<Enums />} />
                                <Route path="/abac" element={<ABACPanel />} />
                                <Route path="/error" element={<ErrorMessage />} />
                            </Routes>
                        </div>
                    </div>
                </div>
                <div className="col-1"></div>
            </div>
        </Router>
    );
}

export default MainApp;